// Mirrors app/utils/money.js on the API side. No FX conversion anywhere -
// an invoice is raised and paid in one currency and formatted in that
// currency; this just renders whatever the row says.
export const SUPPORTED_CURRENCIES = {
  GBP: { symbol: '£', locale: 'en-GB' },
  USD: { symbol: '$', locale: 'en-US' },
  EUR: { symbol: '€', locale: 'en-IE' }
};

export const DEFAULT_CURRENCY = 'GBP';

export const normalizeCurrency = (code) => {
  const upper = String(code || '').toUpperCase();
  return SUPPORTED_CURRENCIES[upper] ? upper : DEFAULT_CURRENCY;
};

export const currencySymbol = (code) => SUPPORTED_CURRENCIES[normalizeCurrency(code)].symbol;

export const formatMoney = (amount, code) => {
  const currency = normalizeCurrency(code);
  return new Intl.NumberFormat(SUPPORTED_CURRENCIES[currency].locale, {
    style: 'currency',
    currency
  }).format(Number(amount) || 0);
};
